module.exports = __webpack_public_path__ + "img/helpbuttonPressed.5c193fbb.png";